import { render } from "./notication_card.vue?vue&type=template&id=38370948"
import script from "./notication_card.vue?vue&type=script&lang=js"
export * from "./notication_card.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__